import {createPopper} from '@popperjs/core';

export function initTooltips(scope: Document | HTMLElement = document) {
  const tooltipWrapElems: NodeListOf<HTMLElement> = scope.querySelectorAll('.js-tooltip');
  for (let i = 0; i < tooltipWrapElems.length; i++) {
    initTooltip(tooltipWrapElems[i]);
  }
}

export function initTooltip(tooltipElement: HTMLElement) {
  const tooltipContent = tooltipElement.dataset.tooltip;
  if (tooltipContent) {
    tooltipElement.classList.add('tooltip__wrap');
    if (tooltipElement.dataset.tooltipColor) {
      tooltipElement.classList.add('tooltip__wrap--' + tooltipElement.dataset.tooltipColor);
    }
    if (tooltipElement.dataset.tooltipSize) {
      tooltipElement.classList.add('tooltip__wrap--' + tooltipElement.dataset.tooltipSize + 'Size');
    }
    if (tooltipElement.dataset.infoIcon) {
      tooltipElement.classList.add('tooltip__wrap--infoIcon');
      if (!tooltipElement.dataset.icon) {
        tooltipElement.innerHTML = 'i';
      }
    }
    if (tooltipElement.dataset.icon) {
      tooltipElement.classList.add('tooltip__wrap--infoIcon');
      tooltipElement.innerHTML = tooltipElement.dataset.icon;
    }
    const tooltipElem = document.createElement('span');
    tooltipElem.classList.add('tooltip');
    tooltipElem.innerHTML = tooltipContent;

    const tooltipArrow = document.createElement('span');
    tooltipArrow.classList.add('tooltip__arrow');
    tooltipArrow.dataset.popperArrow = '1';
    tooltipElement.appendChild(tooltipElem);
    tooltipElem.appendChild(tooltipArrow);

    const position: any = tooltipElement.dataset.position || 'top';

    createPopper(tooltipElement, tooltipElem, {
      placement: position,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
        {
          name: 'flip',
          enabled: true,
        },
      ],
    });
  }
}

export function tooltipDirective(el, binding, vnode) {
  if (!el.dataset.tooltip) {
    el.dataset.tooltip = binding.value;
  }
  if (!el.dataset.tooltipColor) {
    el.dataset.tooltipColor = 'white';
  }
  initTooltip(el);
}
